const STORAGE_KEY = "hexaworld_player_id";

function fallbackId() {
  return "p_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
}

export function getOrCreatePlayerId() {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = (crypto && "randomUUID" in crypto)
      ? crypto.randomUUID()
      : fallbackId();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function setGaUserId(playerId) {
  try {
    const gtag = window.gtag;
    if (!gtag) return;
    gtag("set", { user_id: playerId });
  } catch {
    // swallow
  }
}
